/* ================================================================== */
/*  Web3Forms — server-less form delivery for the "Price on request"   */
/*  / "Send a request" enquiries.                                       */
/*                                                                      */
/*  The access key is safe to ship in client code (that is how         */
/*  Web3Forms is designed). Set it via VITE_WEB3FORMS_KEY. When it is   */
/*  absent (e.g. local dev without the key) callers fall back to a      */
/*  mailto: hand-off so the form still does something.                  */
/* ================================================================== */

const ENDPOINT = 'https://api.web3forms.com/submit'

export const WEB3FORMS_KEY = import.meta.env.VITE_WEB3FORMS_KEY ?? ''
export const web3formsEnabled = WEB3FORMS_KEY.length > 0

/** POST a set of fields to Web3Forms. Throws on network / non-success. */
export async function submitWeb3Form(fields: Record<string, string>): Promise<void> {
  const res = await fetch(ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ access_key: WEB3FORMS_KEY, ...fields }),
  })
  const data = (await res.json().catch(() => null)) as { success?: boolean; message?: string } | null
  if (!res.ok || !data?.success) {
    throw new Error(data?.message || `Request failed (${res.status})`)
  }
}
